<template>
  <el-input :size="size || 'medium'" :value="phoneRaw" @input="onInput">
    <el-select
      slot="prepend"
      v-model="selectedDial"
      style="width: 110px"
      :size="size || 'medium'"
      filterable
      @change="onChange"
    >
      <el-option
        v-for="c in countryCodes"
        :key="c.code"
        :label="`${c.flag} ${c.dial}`"
        :value="c.dial"
      />
    </el-select>
  </el-input>
</template>

<script>
import countryCodes from "@/assets/uilt/countryCodes";

export default {
  name: "PhoneInput",
  props: {
    value: { type: String, default: "" },
    size: { type: String, default: "medium" },
  },
  data() {
    return {
      countryCodes,
      selectedDial: "+227",
      phoneRaw: "",
    };
  },
  /*watch: {
    value: {
      immediate: true,
      handler(val) {
        if (!val) return;
        const phone = String(val);
        const matched = this.countryCodes.find((c) => phone.startsWith(c.dial));
        if (matched) {
          this.selectedDial = matched.dial;
          this.phoneRaw = phone.slice(matched.dial.length);
        } else {
          this.phoneRaw = phone;
        }
      },
    },
  },*/

  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.phoneRaw = "";
          this.selectedDial = "+227";
          return;
        }
        const phone = String(val);

        const full = (this.selectedDial + this.phoneRaw).replace(/\s/g, "");
        if (phone === full) return;

        const matched = this.countryCodes.find((c) => phone.startsWith(c.dial));
        if (matched) {
          this.selectedDial = matched.dial;
          this.phoneRaw = phone.slice(matched.dial.length);
        } else {
          this.phoneRaw = phone;
        }
      },
    },
  },
  methods: {
    onInput(val) {
      this.phoneRaw = val;
      const full = (this.selectedDial + val).replace(/\s/g, "");
      this.$emit("input", full);
      this.$emit("change", full);
      this.$emit("phone-input", full);
    },
    onChange() {
      const full = (this.selectedDial + this.phoneRaw).replace(/\s/g, "");
      this.$emit("input", full);
      this.$emit("change", full);
      this.$emit("phone-input", full);
    },
  },
};
</script>
